module.exports = __webpack_public_path__ + "static/media/4-1.e3e574f1.mp3";